import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  StyledToggle,
  ToggleLabel,
  ReadMoreToggleLabel,
  ToggleText,
  Container,
  ReadMoreToggleText,
  ReadMore
} from './styled';

const Toggle = ({
  children,
  variant,
  formik,
  name,
  disabled,
  onChange,
  isChecked,
  className
}) => {
  const handleChangeWithFormik = () => {
    formik.setFieldValue(name, !formik.values[name]);
  };

  const handleChange = () => {
    onChange();
  };

  return (
    <Container className={className} variant={variant}>
      <StyledToggle
        type="checkbox"
        checked={formik ? formik.values[name] : isChecked}
        id={name}
        disabled={disabled}
        onChange={formik ? handleChangeWithFormik : handleChange}
        variant={variant}
      />
      <ToggleLabel
        htmlFor="checkbox"
        disabled={disabled}
        onClick={formik ? handleChangeWithFormik : handleChange}
        variant={variant}
      />
      <ToggleText variant={variant}>{children}</ToggleText>
    </Container>
  );
};

Toggle.defaultProps = {
  children: '',
  disabled: false,
  formik: null,
  variant: 'dark',
  onChange: () => {},
  isChecked: false,
  className: ''
};

Toggle.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  formik: PropTypes.object,
  variant: PropTypes.string,
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
  className: PropTypes.string
};

const ReadMoreToggle = ({
  children,
  variant,
  formik,
  name,
  disabled,
  onChange,
  isChecked,
  extraText,
  className
}) => {
  const [readMore, setReadMore] = useState(false);

  const handleChangeWithFormik = () => {
    formik.setFieldValue(name, !formik.values[name]);
  };

  const handleChange = () => {
    onChange();
  };

  return (
    <Container className={className}>
      <StyledToggle
        type="checkbox"
        checked={formik ? formik.values[name] : isChecked}
        id={name}
        disabled={disabled}
        onChange={formik ? handleChangeWithFormik : handleChange}
      />
      <ReadMoreToggleLabel
        htmlFor="checkbox"
        disabled={disabled}
        onClick={formik ? handleChangeWithFormik : handleChange}
      />

      <ReadMoreToggleText variant={variant}>
        <b>{children}</b>
        {readMore && (
          <span>
            <br />
            {extraText}
          </span>
        )}
        <ReadMore
          onClick={(e) => {
            e.preventDefault();
            setReadMore(!readMore);
          }}
        >
          {readMore ? 'Show less' : 'Read more'}
        </ReadMore>
      </ReadMoreToggleText>
    </Container>
  );
};

ReadMoreToggle.propTypes = {
  ...Toggle.propTypes,
  extraText: PropTypes.string.isRequired
};

export { ReadMoreToggle };
export default Toggle;
